export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/clothing.b3d9b93.svg";